var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProportion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1751461120062,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 62198,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M486.105058 51.989846C217.657489 51.989846 0.09998 269.547354 0.09998 537.994923c0 268.347588 217.557508 486.005077 486.005078 486.005077 268.347588 0 486.005077-217.557508 486.005077-486.005077H486.105058V51.989846z",
    fill: "currentColor",
    "p-id": 62199,
    "data-spm-anchor-id": "a313x.search_index.0.i52.46c83a815s2V0n",
    className: "selected"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M537.894942 0.09998v486.005078h486.005078C1023.90002 217.657489 806.342511 0.09998 537.894942 0.09998z",
    fill: "rgb(178, 228, 193)",
    "p-id": 62200,
    "data-spm-anchor-id": "a313x.search_index.0.i54.46c83a815s2V0n",
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProportion);
export default __webpack_public_path__ + "static/media/proportion.74d181685427feb1e05a5707723ce3d4.svg";
export { ForwardRef as ReactComponent };